"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "node_modules/lodash/_freeGlobal.js"(exports, module2) {
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module2.exports = freeGlobal;
  }
});

// node_modules/lodash/_root.js
var require_root = __commonJS({
  "node_modules/lodash/_root.js"(exports, module2) {
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module2.exports = root;
  }
});

// node_modules/lodash/isFinite.js
var require_isFinite = __commonJS({
  "node_modules/lodash/isFinite.js"(exports, module2) {
    var root = require_root();
    var nativeIsFinite = root.isFinite;
    function isFinite2(value) {
      return typeof value == "number" && nativeIsFinite(value);
    }
    module2.exports = isFinite2;
  }
});

// src/components/VideoPlayer/index.tsx
var VideoPlayer_exports = {};
__export(VideoPlayer_exports, {
  VideoPlayer: () => VideoPlayerContainer,
  VideoPlayerPlayPausePlacement: () => VideoPlayerPlayPausePlacement,
  getVideoPlayerSettings: () => getVideoPlayerSettings,
  rememberVideoPlayerSettings: () => rememberVideoPlayerSettings,
  storageKeys: () => storageKeys,
  useVideoProgress: () => useVideoProgress
});
module.exports = __toCommonJS(VideoPlayer_exports);

// src/components/VideoPlayer/VideoPlayerContainer.tsx
var import_react8 = __toESM(require("react"));

// src/components/VideoPlayer/VideoPlayerOverlay.tsx
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
function VideoPlayerOverlay({
  className,
  onClick
}) {
  return /* @__PURE__ */ import_react.default.createElement(
    "div",
    {
      className: (0, import_classnames.default)(className, [
        "v2-fixed v2-inset-0 v2-bg-black v2-bg-opacity-50 v2-overflow-y-auto v2-w-full v2-h-full v2-z-30"
      ]),
      onClick
    }
  );
}

// src/components/VideoPlayer/VideoPlayerComponent.tsx
var import_react7 = __toESM(require("react"));
var import_classnames5 = __toESM(require("classnames"));

// src/components/VideoPlayer/VideoControls.tsx
var import_react5 = __toESM(require("react"));
var import_react_fontawesome = require("@fortawesome/react-fontawesome");
var import_classnames4 = __toESM(require("classnames"));
var import_styled = __toESM(require("@emotion/styled"));

// node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var faCirclePlay = {
  prefix: "fas",
  iconName: "circle-play",
  icon: [512, 512, [61469, "play-circle"], "f144", "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"]
};
var faCirclePause = {
  prefix: "fas",
  iconName: "circle-pause",
  icon: [512, 512, [62092, "pause-circle"], "f28b", "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faXmark = {
  prefix: "fas",
  iconName: "xmark",
  icon: [320, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"]
};
var faTimes = faXmark;

// src/theme/colors.ts
var palette = {
  black: "#000000",
  white: "#FFFFFF",
  red: ["#F9DEDC", "#F0ADA8", "#E77B73", "#DE4A3F", "#C6413E"],
  orange: [
    "#FFEEE6",
    "#FFDCCC",
    "#FFB99A",
    "#FF9767",
    "#FF7435",
    "#FF5102",
    "#CC4102",
    "#993101",
    "#662001",
    "#331000"
  ],
  yellow: [
    "#F7F4EA",
    "#FFF6CC",
    "#FFEC9A",
    "#FFE367",
    "#FFD935",
    "#FFD002",
    "#CCA602",
    "#997D01",
    "#665301",
    "#332A00"
  ],
  green: [
    "#FAFFEF",
    "#E7F4CC",
    "#CFE999",
    "#B8DD67",
    "#A0D234",
    "#88C701",
    "#6D9F01",
    "#527701",
    "#365000",
    "#1B2800"
  ],
  turquoise: ["#E3F2F2", "#BADEDE", "#9ED0D1", "#4EA4A6", "#22A0AC", "#1C7E87"],
  blue: [
    "#F5F7FF",
    "#CCD6FF",
    "#9AADFF",
    "#6783FF",
    "#355AFF",
    "#0231FF",
    "#0227CC",
    "#011D99",
    "#011466",
    "#000A33"
  ],
  purple: ["#E6E5F0", "#B5B1D3", "#847CB6", "#675EA5", "#514983"],
  pink: ["#FFEFF4", "#FFD0DF", "#F2A6BE", "#EC799D", "#D0577D"],
  brown: ["#9B803D", "#8E652A", "#5B4028", "#473A31", "#2D241D", "#1C1616"],
  neutral: [
    "#F2F2F2",
    "#E2E3E7",
    "#C4C7CF",
    "#A7AAB8",
    "#898EA0",
    "#6C7288",
    "#565B6D",
    "#414452",
    "#2B2E36",
    "#16171B"
  ],
  magenta: [
    "#FFF8FF",
    "#F0CEEA",
    "#E19DD6",
    "#D16DC1",
    "#C23CAD",
    "#B30B98",
    "#A10A89",
    "#7D086A",
    "#5A064C",
    "#36032E"
  ]
};
var colors = {
  white: palette.white,
  black: palette.black,
  current: "currentColor",
  transparent: "transparent",
  neutral: {
    DEFAULT: palette.neutral[9],
    50: palette.neutral[0],
    100: palette.neutral[1],
    200: palette.neutral[2],
    300: palette.neutral[3],
    400: palette.neutral[4],
    500: palette.neutral[5],
    600: palette.neutral[6],
    700: palette.neutral[7],
    800: palette.neutral[8],
    900: palette.neutral[9]
  },
  red: {
    DEFAULT: palette.red[3],
    100: palette.red[0],
    300: palette.red[1],
    500: palette.red[2],
    700: palette.red[3],
    900: palette.red[4]
  },
  orange: {
    DEFAULT: palette.orange[5],
    50: palette.orange[0],
    100: palette.orange[1],
    200: palette.orange[2],
    300: palette.orange[3],
    400: palette.orange[4],
    500: palette.orange[5],
    600: palette.orange[6],
    700: palette.orange[7],
    800: palette.orange[8],
    900: palette.orange[9]
  },
  yellow: {
    DEFAULT: palette.yellow[5],
    50: palette.yellow[0],
    100: palette.yellow[1],
    200: palette.yellow[2],
    300: palette.yellow[3],
    400: palette.yellow[4],
    500: palette.yellow[5],
    600: palette.yellow[6],
    700: palette.yellow[7],
    800: palette.yellow[8],
    900: palette.yellow[9]
  },
  green: {
    DEFAULT: palette.green[5],
    50: palette.green[0],
    100: palette.green[1],
    200: palette.green[2],
    300: palette.green[3],
    400: palette.green[4],
    500: palette.green[5],
    600: palette.green[6],
    700: palette.green[7],
    800: palette.green[8],
    900: palette.green[9]
  },
  turquoise: {
    DEFAULT: palette.turquoise[4],
    100: palette.turquoise[0],
    300: palette.turquoise[1],
    500: palette.turquoise[2],
    600: palette.turquoise[3],
    700: palette.turquoise[4],
    900: palette.turquoise[5]
  },
  blue: {
    DEFAULT: palette.blue[5],
    50: palette.blue[0],
    100: palette.blue[1],
    200: palette.blue[2],
    300: palette.blue[3],
    400: palette.blue[4],
    500: palette.blue[5],
    600: palette.blue[6],
    700: palette.blue[7],
    800: palette.blue[8],
    900: palette.blue[9]
  },
  purple: {
    DEFAULT: palette.purple[3],
    100: palette.purple[0],
    300: palette.purple[1],
    500: palette.purple[2],
    700: palette.purple[3],
    900: palette.purple[4]
  },
  pink: {
    DEFAULT: palette.pink[3],
    100: palette.pink[0],
    300: palette.pink[1],
    500: palette.pink[2],
    700: palette.pink[3],
    900: palette.pink[4]
  },
  brown: {
    DEFAULT: palette.brown[3],
    50: palette.brown[0],
    100: palette.brown[1],
    300: palette.brown[2],
    500: palette.brown[3],
    700: palette.brown[4],
    900: palette.brown[5]
  },
  magenta: {
    DEFAULT: palette.magenta[5],
    50: palette.magenta[0],
    100: palette.magenta[1],
    200: palette.magenta[2],
    300: palette.magenta[3],
    400: palette.magenta[4],
    500: palette.magenta[5],
    600: palette.magenta[6],
    700: palette.magenta[7],
    800: palette.magenta[8],
    900: palette.magenta[9]
  }
};

// src/theme/typography.ts
var typography = {
  standard: "Lato"
};

// src/theme/index.ts
var theme = {
  colors,
  extend: {
    screens: {
      xxs: "320px",
      xs: "425px",
      // Widget mobile breakpoint
      wm: "500px"
    },
    fontSize: {
      xxs: [
        ".5rem",
        {
          lineHeight: "0.75rem"
        }
      ]
    },
    fontFamily: {
      sans: ["Circular Std", typography.standard, "sans-serif"],
      circular: ["Circular Std", "Arial", "san-serif"]
    },
    boxShadow: {
      top: "0 -4px 4px 0 rgba(166, 166, 166, 0.13)",
      around: "0 1px 10px 0 rgba(0, 0, 0, 0.16)",
      "3xl": "5px 3px 6px #00000029"
    },
    dropShadow: {
      text: "0px 3px 6px #00000029"
    },
    zIndex: {
      "99": 99
    },
    spacing: {
      "30": "7.5rem",
      "37": "9.375rem"
    },
    animation: {
      "fade-in-100": "fade-in .1s linear forwards",
      "fade-in-150": "fade-in .15s linear forwards",
      "fade-in": "fade-in .25s linear forwards",
      "fade-out-100": "fade-out .1s linear forwards",
      "fade-out-150": "fade-out .15s linear forwards",
      "fade-out": "fade-out .25s linear forwards",
      "fade-in-down-150": "fade-in-down .15s linear 1",
      "fade-in-down": "fade-in-down .25s linear 1",
      "fade-out-down-150": "fade-out-down .15s linear 1",
      "fade-out-down": "fade-out-down .25s linear 1",
      "fade-in-up-150": "fade-in-up .15s linear 1",
      "fade-in-up": "fade-in-up .25s linear 1",
      "fade-out-up-150": "fade-out-up .15s linear 1",
      "fade-out-up": "fade-out-up .25s linear 1",
      "fade-in-left-150": "fade-in-left .15s linear 1",
      "fade-in-left": "fade-in-left .25s linear 1",
      "fade-out-left-150": "fade-out-left .15s linear 1",
      "fade-out-left": "fade-out-left .25s linear 1",
      "fade-in-right-150": "fade-in-right .15s linear 1",
      "fade-in-right": "fade-in-right .25s linear 1",
      "fade-out-right-150": "fade-out-right .15s linear 1",
      "fade-out-right": "fade-out-right .25s linear 1",
      "rotate-360": "rotate-360 2s linear infinite"
    },
    keyframes: {
      "rotate-360": {
        "0%": { transform: "rotate(0deg)" },
        "100%": { transform: "rotate(360deg)" }
      },
      "fade-in": {
        "0%": { opacity: "0" },
        "100%": { opacity: "1" }
      },
      "fade-out": {
        "0%": { opacity: "1" },
        "100%": { opacity: "0" }
      },
      "fade-in-down": {
        "0%": { opacity: "0", transform: "translateY(-20px)" },
        "100%": { opacity: "1", transform: "translateY(0)" }
      },
      "fade-out-down": {
        "0%": { opacity: "1", transform: "translateY(0)" },
        "100%": { opacity: "0", transform: "translateY(20px)" }
      },
      "fade-in-up": {
        "0%": { opacity: "0", transform: "translateY(20px)" },
        "100%": { opacity: "1", transform: "translateY(0)" }
      },
      "fade-out-up": {
        "0%": { opacity: "1", transform: "translateY(0)" },
        "100%": { opacity: "0", transform: "translateY(-20px)" }
      },
      "fade-in-left": {
        "0%": { opacity: "0", transform: "translateX(20px)" },
        "100%": { opacity: "1", transform: "translateX(0)" }
      },
      "fade-out-left": {
        "0%": { opacity: "1", transform: "translateX(0)" },
        "100%": { opacity: "0", transform: "translateX(-20px)" }
      },
      "fade-in-right": {
        "0%": { opacity: "0", transform: "translateX(-20px)" },
        "100%": { opacity: "1", transform: "translateX(0)" }
      },
      "fade-out-right": {
        "0%": { opacity: "1", transform: "translateX(0)" },
        "100%": { opacity: "0", transform: "translateX(20px)" }
      }
    }
  }
};

// src/components/VideoPlayer/VideoControls.tsx
var import_isFinite = __toESM(require_isFinite());

// src/components/VideoPlayer/hooks/useVideoProgress.ts
var import_react2 = require("react");
function useVideoProgress({
  videoRef,
  onProgress,
  intervalDelay = 250,
  forceUseInterval = false
}) {
  const [intervalId, setIntervalId] = (0, import_react2.useState)();
  const [playing, setPlaying] = (0, import_react2.useState)(false);
  function handlePlayEvent() {
    setPlaying(true);
  }
  function handlePauseEvent() {
    setPlaying(false);
  }
  (0, import_react2.useEffect)(() => {
    if (videoRef == null ? void 0 : videoRef.current) {
      videoRef.current.addEventListener("play", handlePlayEvent);
      videoRef.current.addEventListener("pause", handlePauseEvent);
    }
    return () => {
      if (!(videoRef == null ? void 0 : videoRef.current))
        return;
      videoRef.current.removeEventListener("play", handlePlayEvent);
      videoRef.current.removeEventListener("pause", handlePauseEvent);
    };
  }, [videoRef == null ? void 0 : videoRef.current]);
  const supportsTimeUpdate = (0, import_react2.useMemo)(() => {
    var _a;
    return !forceUseInterval && ((_a = (videoRef == null ? void 0 : videoRef.current) && "ontimeupdate" in videoRef.current) != null ? _a : false);
  }, [videoRef == null ? void 0 : videoRef.current]);
  function handleTimeUpdate() {
    var _a;
    ((_a = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a.currentTime) != null && (onProgress == null ? void 0 : onProgress(videoRef.current.currentTime));
  }
  (0, import_react2.useEffect)(() => {
    if (supportsTimeUpdate && (videoRef == null ? void 0 : videoRef.current) && onProgress) {
      videoRef.current.addEventListener("timeupdate", handleTimeUpdate);
    }
    return () => {
      if (!(videoRef == null ? void 0 : videoRef.current))
        return;
      videoRef.current.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, [supportsTimeUpdate, onProgress]);
  (0, import_react2.useEffect)(() => {
    if (onProgress && playing && (videoRef == null ? void 0 : videoRef.current) && !videoRef.current.paused && !supportsTimeUpdate) {
      setIntervalId(
        setInterval(() => {
          var _a;
          ((_a = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a.currentTime) != null && (onProgress == null ? void 0 : onProgress(videoRef.current.currentTime));
        }, intervalDelay)
      );
    } else if (intervalId) {
      clearInterval(intervalId);
    }
    return () => intervalId && clearInterval(intervalId);
  }, [playing, supportsTimeUpdate]);
}

// src/utils/elapsed.ts
var import_luxon = require("luxon");
function elapsed(input, options) {
  const duration = (import_luxon.Duration.isDuration(input) ? input : import_luxon.Duration.fromObject({ seconds: input })).shiftTo("hours", "minutes", "seconds");
  const shouldPadMinutes = !(options == null ? void 0 : options.noPadMinutes);
  const format = ` ${duration.hours ? "hh:" : ""}${shouldPadMinutes ? "mm:ss" : "m:ss"}`;
  return duration.toFormat(format);
}

// src/components/Transcript/Transcript.tsx
var import_react3 = __toESM(require("react"));
var import_classnames2 = __toESM(require("classnames"));
var SENTENCE_ENDING_THRESHOLD_MS = 0.15;
var MAX_WORDS_PER_SENTENCE = 15;
function Transcript({
  videoRef,
  sentences,
  mode = "sentence" /* Sentence */,
  maxWordsPerSentence = MAX_WORDS_PER_SENTENCE,
  containerClassName,
  className,
  onClick
}) {
  const [currentTranscription, setCurrentTranscription] = (0, import_react3.useState)();
  const [sentenceEnding, setSentenceEnding] = (0, import_react3.useState)(false);
  const parsedSentences = (0, import_react3.useMemo)(() => {
    if (!sentences || sentences.length === 0)
      return [];
    return sentences == null ? void 0 : sentences.reduce((sentences2, sentence) => {
      var _a, _b, _c;
      const currentSentence = {
        text: sentence.text,
        start: sentence.start / 1e3,
        end: sentence.end / 1e3,
        words: (_a = sentence == null ? void 0 : sentence.words) == null ? void 0 : _a.reduce((words, word) => {
          return [
            ...words,
            {
              text: word.text,
              start: word.start / 1e3,
              end: word.end / 1e3
            }
          ];
        }, [])
      };
      if ((currentSentence == null ? void 0 : currentSentence.words) && ((_b = currentSentence == null ? void 0 : currentSentence.words) == null ? void 0 : _b.length) > maxWordsPerSentence) {
        const chunkedWords = currentSentence == null ? void 0 : currentSentence.words.reduce(
          (words, word, index) => {
            const chunkIndex = Math.floor(index / maxWordsPerSentence);
            if (!words[chunkIndex]) {
              words[chunkIndex] = [];
            }
            words[chunkIndex].push(word);
            return words;
          },
          []
        );
        return [
          ...sentences2,
          ...(_c = chunkedWords == null ? void 0 : chunkedWords.reduce((sentences3, words) => {
            var _a2, _b2;
            return [
              ...sentences3,
              {
                text: words.map((word) => word.text).join(" "),
                start: (_a2 = words[0]) == null ? void 0 : _a2.start,
                end: (_b2 = words[words.length - 1]) == null ? void 0 : _b2.end,
                words
              }
            ];
          }, [])) != null ? _c : []
        ];
      }
      return [...sentences2, currentSentence];
    }, []);
  }, [sentences, maxWordsPerSentence]);
  const hasActiveTranscriptions = (0, import_react3.useMemo)(
    () => currentTranscription !== "" && currentTranscription !== void 0,
    [currentTranscription]
  );
  (0, import_react3.useEffect)(() => {
    if (!(videoRef == null ? void 0 : videoRef.current))
      return;
    const video = videoRef.current;
    const handleTimeUpdate = () => {
      var _a;
      const currentTime = video.currentTime;
      const currentTranscription2 = parsedSentences.find(
        (transcription) => currentTime >= transcription.start && currentTime <= transcription.end
      );
      if (currentTranscription2 && currentTime <= (currentTranscription2 == null ? void 0 : currentTranscription2.end) && (currentTranscription2 == null ? void 0 : currentTranscription2.end) - currentTime <= SENTENCE_ENDING_THRESHOLD_MS) {
        setSentenceEnding(true);
      } else {
        setSentenceEnding(false);
      }
      switch (mode) {
        case "sentence" /* Sentence */: {
          setCurrentTranscription(
            currentTranscription2 ? currentTranscription2.text : ""
          );
          break;
        }
        case "word_per_word" /* WordPerWord */: {
          const compiledWords = (_a = currentTranscription2 == null ? void 0 : currentTranscription2.words) == null ? void 0 : _a.filter(
            (word) => currentTime >= currentTranscription2.start && currentTime >= word.end || currentTime >= word.start && currentTime <= word.end
          ).reduce((words, word) => {
            return [...words, word.text];
          }, []);
          setCurrentTranscription(
            compiledWords && (compiledWords == null ? void 0 : compiledWords.length) > 0 ? compiledWords.join(" ") : ""
          );
          break;
        }
      }
    };
    video.addEventListener("timeupdate", handleTimeUpdate);
    return () => {
      video.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, [videoRef == null ? void 0 : videoRef.current, parsedSentences, mode]);
  return /* @__PURE__ */ import_react3.default.createElement(
    "div",
    {
      className: (0, import_classnames2.default)(
        containerClassName,
        "v2-rounded v2-cursor-pointer v2-select-none v2-w-auto"
      ),
      onClick
    },
    /* @__PURE__ */ import_react3.default.createElement(
      "span",
      {
        className: (0, import_classnames2.default)(className, {
          "v2-bg-black/50 v2-text-white v2-text-base v2-p-0.5 v2-select-none v2-animate-fade-in-100 v2-whitespace-normal v2-font-circular": hasActiveTranscriptions,
          "v2-animate-fade-out-100": sentenceEnding
        })
      },
      currentTranscription
    )
  );
}

// src/components/Transcript/CCButton.tsx
var import_react4 = __toESM(require("react"));
var import_classnames3 = __toESM(require("classnames"));
function CCButton({
  show = false,
  onShowClick,
  outerContainerClassName,
  innerContainerClassName,
  iconClassName
}) {
  return /* @__PURE__ */ import_react4.default.createElement(
    "div",
    {
      className: (0, import_classnames3.default)(
        "v2-pr-2.5 v2-pt-2.5 v2-cursor-pointer",
        outerContainerClassName
      )
    },
    /* @__PURE__ */ import_react4.default.createElement(
      "div",
      {
        className: (0, import_classnames3.default)(
          innerContainerClassName,
          [
            "v2-flex v2-items-center v2-p-0.5",
            "v2-rounded-md v2-opacity-25 v2-select-none v2-bg-black"
          ],
          {
            "hover:v2-opacity-50 v2-transition-all ": !show,
            "!v2-opacity-25 v2-bg-black": show
          }
        ),
        onClick: (e) => {
          e.stopPropagation();
          onShowClick == null ? void 0 : onShowClick(!show);
        }
      },
      /* @__PURE__ */ import_react4.default.createElement(
        "div",
        {
          className: (0, import_classnames3.default)(
            iconClassName,
            [
              "v2-text-center v2-items-center v2-justify-center v2-flex v2-text-xs",
              "v2-p-[2.5px] v2-py-0 v2-rounded-md v2-min-w-[25px] v2-min-h-[20px] ",
              "v2-border v2-border-[1.5px] v2-border-white v2-border-solid v2-font-bold",
              "v2-font-circular"
            ],
            {
              "v2-bg-black v2-text-white": !show,
              "v2-bg-white v2-text-neutral": show
            }
          )
        },
        "CC"
      )
    )
  );
}

// src/utils/localStorage.ts
var import_localforage = __toESM(require("localforage"));
var keyToStr = (key) => key.join(".");
function remember(key, value) {
  return import_localforage.default.setItem(keyToStr(key), JSON.stringify(value));
}
function recall(key) {
  return __async(this, null, function* () {
    const json = yield import_localforage.default.getItem(keyToStr(key));
    if (json) {
      return JSON.parse(json);
    }
    return null;
  });
}

// src/components/VideoPlayer/settings.ts
var storageKeys = {
  all: ["bonjoro", "video-player-settings"]
};
function rememberVideoPlayerSettings(settings) {
  return __async(this, null, function* () {
    const currentSettings = yield getVideoPlayerSettings();
    return remember(storageKeys.all, __spreadValues(__spreadValues({}, currentSettings), settings));
  });
}
function getVideoPlayerSettings() {
  return recall(storageKeys.all);
}

// src/components/VideoPlayer/VideoControls.tsx
var volumeIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/volume-white.svg";
var volumeMuteIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/volume-mute-white.svg";
var fullScreenIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/full-screen-white.svg";
var exitFullScreenIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/exit-full-screen-white.svg";
var newTabIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/new-tab-white.svg";
var actionIconClass = "v2-overflow-visible v2-z-10 v2-cursor-pointer v2-select-none";
var NewTabIcon = import_styled.default.img`
  ${({ ctaHoverColor }) => `
    &:hover {
      background-color: ${ctaHoverColor != null ? ctaHoverColor : "transparent"};
    }
  `}
`;
var VideoProgress = import_styled.default.progress`
  &::-webkit-progress-bar {
    background-color: ${colors.neutral[200]};
  }

  &::-webkit-progress-value {
    background: ${colors.yellow[500]};
  }

  &::-moz-progress-bar {
    background: ${colors.yellow[500]};
  }
`;
var VideoProgressSliderThumb = import_styled.default.input`
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
  }

  &::-webkit-slider-thumb {
    width: 10px;
    height: 10px;
    background: ${colors.yellow[500]};
    cursor: ew-resize;
    z-index: 50;
  }

  &:hover::-moz-range-thumb {
    width: 10px;
    height: 10px;
    background: ${colors.yellow[500]};
    cursor: ew-resize;
  }
`;
var CtaContainer = import_styled.default.div`
  ${({ ctaHoverColor }) => `
    &:hover {
      background-color: ${ctaHoverColor != null ? ctaHoverColor : "transparent"};
    }
  `}
`;
function VideoControls({
  fullScreen,
  playing,
  muted,
  showControls = true,
  leftHeaderComponent,
  footerComponent,
  initialTranscriptionState = "closed",
  transcription,
  transcriptMode,
  transcriptionTogglerPosition,
  transcriptionMaxWordsPerSentence,
  transcriptionClassName,
  transcriptionContainerClassName,
  ctaHoverColor,
  hideClose,
  hideNewTab,
  hidePlayPause,
  hideMuteUnmute,
  hideFullScreen,
  hideTranscription,
  onPlayPauseClick,
  onMuteUnmuteClick,
  onFullScreenClick,
  onNewTabClick,
  onCloseClick,
  videoRef,
  hideTimer,
  showProgressBar,
  fadeControlsOnPlay,
  closedCaptionClassName,
  playPauseStyle,
  playPauseClassName,
  playPausePlacement
}) {
  var _a;
  const [currentTime, setCurrentTime] = (0, import_react5.useState)(0);
  const [showTranscription, setShowTranscription] = (0, import_react5.useState)(
    initialTranscriptionState === "open"
  );
  (0, import_react5.useEffect)(() => {
    void getVideoPlayerSettings().then((settings) => {
      var _a2;
      if (!settings)
        return;
      setShowTranscription((_a2 = settings.transcriptionEnabled) != null ? _a2 : false);
    });
  }, []);
  const [formattedCurrentTime, formattedDuration, duration] = (0, import_react5.useMemo)(() => {
    if (!(videoRef == null ? void 0 : videoRef.current)) {
      return [null, null];
    }
    const duration2 = videoRef.current.duration;
    const formattedCurrentTime2 = elapsed(currentTime, { noPadMinutes: true });
    if (!(0, import_isFinite.default)(duration2)) {
      return [null, null];
    }
    const formattedDuration2 = elapsed(duration2, { noPadMinutes: true });
    return [formattedCurrentTime2, formattedDuration2, duration2];
  }, [videoRef == null ? void 0 : videoRef.current, (_a = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a.duration, currentTime]);
  useVideoProgress({
    videoRef,
    onProgress: setCurrentTime,
    intervalDelay: 100,
    forceUseInterval: true
  });
  const onVideoSeek = (0, import_react5.useCallback)(
    (ev) => {
      var _a2;
      ev.preventDefault();
      if (typeof ((_a2 = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a2.currentTime) === "undefined")
        return;
      videoRef.current.currentTime = Number(ev.target.value);
    },
    [videoRef == null ? void 0 : videoRef.current]
  );
  const onTranscriptionClick = (show) => {
    void rememberVideoPlayerSettings({
      transcriptionEnabled: show
    });
    setShowTranscription(show);
  };
  const transciptionTogglerProps = {
    show: showTranscription,
    onShowClick: onTranscriptionClick,
    outerContainerClassName: closedCaptionClassName
  };
  const hasValidTranscription = transcription != void 0 && transcription.length > 0;
  const fadeControls = !(fadeControlsOnPlay && !playing || !fadeControlsOnPlay);
  const isPlayPausePlacementCenter = playPausePlacement === "center" /* Center */;
  const isPlayPausePlacementLowerLeft = playPausePlacement === "lower-left" /* LowerLeft */;
  const scaleOnHoverClassName = "v2-transition-all v2-duration-200 hover:v2-scale-105";
  return /* @__PURE__ */ import_react5.default.createElement(import_react5.default.Fragment, null, showControls && /* @__PURE__ */ import_react5.default.createElement(
    "div",
    {
      className: "v2-absolute v2-flex v2-flex-col v2-w-full v2-top-0 v2-z-50",
      onClick: onPlayPauseClick
    },
    /* @__PURE__ */ import_react5.default.createElement("div", { className: "v2-flex v2-flex-row v2-justify-between" }, /* @__PURE__ */ import_react5.default.createElement("div", { className: "v2-inline-flex" }, leftHeaderComponent, !hideTranscription && hasValidTranscription && transcriptionTogglerPosition === "left" && /* @__PURE__ */ import_react5.default.createElement(
      CCButton,
      __spreadProps(__spreadValues({}, transciptionTogglerProps), {
        outerContainerClassName: "v2-pl-2.5"
      })
    )), /* @__PURE__ */ import_react5.default.createElement("div", { className: "v2-inline-flex" }, !hideTranscription && hasValidTranscription && transcriptionTogglerPosition === "right" && /* @__PURE__ */ import_react5.default.createElement(CCButton, __spreadValues({}, transciptionTogglerProps)), !hideNewTab && /* @__PURE__ */ import_react5.default.createElement(
      NewTabIcon,
      {
        ctaHoverColor,
        className: (0, import_classnames4.default)(
          actionIconClass,
          "v2-w-7 v2-h-7 v2-p-1",
          scaleOnHoverClassName
        ),
        src: newTabIcon,
        onClick: (e) => {
          e.stopPropagation();
          onNewTabClick == null ? void 0 : onNewTabClick();
        },
        title: "Open in a new window"
      }
    ), !hideClose && /* @__PURE__ */ import_react5.default.createElement("div", { className: "v2-px-1 v2-bg-black v2-bg-opacity-50 v2-h-7 v2-flex v2-items-center" }, /* @__PURE__ */ import_react5.default.createElement(
      import_react_fontawesome.FontAwesomeIcon,
      {
        className: (0, import_classnames4.default)(
          scaleOnHoverClassName,
          "v2-w-5 v2-h-6 v2-text-white v2-cursor-pointer"
        ),
        icon: faTimes,
        onClick: (e) => {
          e.stopPropagation();
          onCloseClick == null ? void 0 : onCloseClick();
        },
        title: "Close"
      }
    ))))
  ), !hidePlayPause && isPlayPausePlacementCenter && /* @__PURE__ */ import_react5.default.createElement(
    "div",
    {
      className: (0, import_classnames4.default)(
        [
          "v2-absolute v2-top-1/2 v2-left-1/2 v2-flex v2-transition-all v2-duration-200",
          "-v2-translate-x-1/2 -v2-translate-y-1/2 v2-z-[20]",
          ""
        ],
        {
          "v2-animate-fade-in": !playing,
          "v2-animate-fade-out": playing
        }
      )
    },
    /* @__PURE__ */ import_react5.default.createElement(
      import_react_fontawesome.FontAwesomeIcon,
      {
        onClick: onPlayPauseClick,
        className: (0, import_classnames4.default)(playPauseClassName, scaleOnHoverClassName, [
          "v2-h-[90px] !v2-w-[50px] v2-text-white v2-cursor-pointer"
        ]),
        icon: playing ? faCirclePause : faCirclePlay,
        title: "Play/Pause",
        style: playPauseStyle
      }
    )
  ), /* @__PURE__ */ import_react5.default.createElement("div", { className: "v2-absolute v2-flex v2-flex-col v2-w-full v2-bottom-0 v2-z-50" }, !hideTranscription && hasValidTranscription && (videoRef == null ? void 0 : videoRef.current) && !(fadeControlsOnPlay && !playing) && /* @__PURE__ */ import_react5.default.createElement("div", { className: "v2-flex v2-items-center v2-justify-center" }, /* @__PURE__ */ import_react5.default.createElement(
    Transcript,
    {
      onClick: onPlayPauseClick,
      sentences: transcription,
      videoRef,
      mode: transcriptMode,
      maxWordsPerSentence: transcriptionMaxWordsPerSentence,
      className: transcriptionClassName,
      containerClassName: (0, import_classnames4.default)(
        transcriptionContainerClassName,
        "v2-text-center v2-w-fit",
        {
          "v2-opacity-0": !showTranscription
        }
      )
    }
  )), showControls && /* @__PURE__ */ import_react5.default.createElement(
    "div",
    {
      className: "v2-flex v2-flex-row v2-justify-between v2-pointer-events-auto v2-z-50 v2-px-3.5 v2-pb-3.5 v2-h-[42px]",
      onClick: onPlayPauseClick
    },
    /* @__PURE__ */ import_react5.default.createElement("div", { className: "v2-flex v2-space-x-3.5 v2-items-center" }, !hidePlayPause && isPlayPausePlacementLowerLeft && !fadeControls && /* @__PURE__ */ import_react5.default.createElement(
      import_react_fontawesome.FontAwesomeIcon,
      {
        onClick: onPlayPauseClick,
        className: (0, import_classnames4.default)(playPauseClassName, [
          "v2-h-[38px] !v2-w-[30px] v2-text-4xl v2-text-white",
          "v2-cursor-pointer v2-animate-fade-in"
        ]),
        icon: playing ? faCirclePause : faCirclePlay,
        title: "Play/Pause",
        style: playPauseStyle
      }
    ), !hideTimer && formattedCurrentTime && formattedDuration && /* @__PURE__ */ import_react5.default.createElement(
      "div",
      {
        className: (0, import_classnames4.default)(
          "v2-group/video-player-timer",
          scaleOnHoverClassName,
          "v2-flex v2-gap-x-1 v2-text-white v2-text-base v2-animate-fade-in"
        )
      },
      /* @__PURE__ */ import_react5.default.createElement("span", { className: "v2-w-[35px] v2-font-circular" }, formattedCurrentTime),
      /* @__PURE__ */ import_react5.default.createElement(
        "span",
        {
          className: (0, import_classnames4.default)(
            "v2-opacity-50 group-hover/video-player-timer:v2-opacity-100",
            "v2-transition-all v2-duration-200 v2-font-circular"
          )
        },
        "/"
      ),
      /* @__PURE__ */ import_react5.default.createElement(
        "span",
        {
          className: (0, import_classnames4.default)(
            "v2-w-[35px] v2-opacity-50 group-hover/video-player-timer:v2-opacity-100",
            "v2-transition-all v2-duration-200 v2-font-circular"
          )
        },
        formattedDuration
      )
    )),
    /* @__PURE__ */ import_react5.default.createElement("div", { className: "v2-inline-flex v2-gap-x-3 v2-items-center" }, !hideMuteUnmute && /* @__PURE__ */ import_react5.default.createElement(
      CtaContainer,
      {
        ctaHoverColor,
        className: (0, import_classnames4.default)(
          scaleOnHoverClassName,
          "v2-p-1 v2-animate-fade-in"
        )
      },
      /* @__PURE__ */ import_react5.default.createElement(
        "img",
        {
          className: (0, import_classnames4.default)(actionIconClass, "v2-w-5 v2-h-5"),
          src: muted ? volumeMuteIcon : volumeIcon,
          title: "Mute/Unmute",
          onClick: (e) => {
            e.stopPropagation();
            onMuteUnmuteClick == null ? void 0 : onMuteUnmuteClick();
          }
        }
      )
    ), !hideFullScreen && /* @__PURE__ */ import_react5.default.createElement(
      CtaContainer,
      {
        ctaHoverColor,
        className: (0, import_classnames4.default)(
          scaleOnHoverClassName,
          "v2-p-1 v2-animate-fade-in"
        )
      },
      /* @__PURE__ */ import_react5.default.createElement(
        "img",
        {
          className: (0, import_classnames4.default)(actionIconClass, "v2-w-5 v2-h-5"),
          src: fullScreen ? exitFullScreenIcon : fullScreenIcon,
          onClick: (e) => {
            e.stopPropagation();
            onFullScreenClick == null ? void 0 : onFullScreenClick();
          },
          title: "Full screen"
        }
      )
    ))
  ), showProgressBar && /* @__PURE__ */ import_react5.default.createElement("div", { className: "v2-flex" }, /* @__PURE__ */ import_react5.default.createElement(
    VideoProgress,
    {
      max: duration == null ? void 0 : duration.toFixed(),
      value: currentTime.toFixed(),
      className: "v2-appearance-none v2-w-full v2-h-[10px] v2-absolute v2-bottom-0 v2-transition-all v2-duration-200"
    }
  ), /* @__PURE__ */ import_react5.default.createElement(
    VideoProgressSliderThumb,
    {
      type: "range",
      className: "v2-appearance-none v2-w-full v2-h-[10px] v2-bg-transparent v2-z-10  v2-cursor-ew-resize v2-transition-all v2-duration-200",
      min: 0,
      max: duration == null ? void 0 : duration.toFixed(),
      value: currentTime.toFixed(),
      onChange: onVideoSeek
    }
  )), footerComponent));
}

// src/utils.ts
var import_react6 = __toESM(require("react"));
function openFullScreen(videoElement) {
  if (videoElement.requestFullscreen) {
    videoElement.requestFullscreen();
  } else if (videoElement.webkitEnterFullscreen) {
    videoElement.webkitEnterFullscreen();
  } else if (videoElement.msRequestFullscreen) {
    videoElement.msRequestFullscreen();
  } else if (videoElement.mozRequestFullScreen) {
    videoElement.mozRequestFullScreen();
  } else {
    throw new Error("fullscreenElement is not supported by this browser");
  }
}

// src/components/VideoPlayer/VideoPlayerComponent.tsx
function VideoPlayerComponent({
  videoUrl,
  videoTitle,
  videoThumbnail,
  videoThumbnailClassName,
  containerClassName,
  videoClassName,
  playPauseStyle,
  playPauseClassName,
  videoStyle,
  showDefaultFullScreen = false,
  showDefaultControls = false,
  autoPlay = false,
  loop = false,
  fullScreen = false,
  children,
  footerComponent,
  leftHeaderComponent,
  initialTranscriptionState,
  transcription,
  transcriptMode = "sentence" /* Sentence */,
  transcriptionTogglerPosition = "right",
  transcriptionMaxWordsPerSentence,
  transcriptionClassName,
  transcriptionContainerClassName,
  preload = "auto",
  playsInline = true,
  hidePlayPause,
  hideMuteUnmute,
  hideFullScreen,
  hideClose,
  hideNewTab,
  hideTranscription,
  hideLoader = false,
  ctaHoverColor,
  onNewTabClick,
  onCloseClick,
  onFullScreenClick,
  onVideoLoaded,
  onThumbnailLoad,
  onThumbnailLoadError,
  onProgress,
  onPlay,
  onPause,
  videoRef,
  containerRef,
  hideTimer,
  showProgressBar,
  fadeControlsOnPlay = false,
  playPausePlacement = "lower-left" /* LowerLeft */,
  rounded,
  forceFirstFrame = true,
  forceShowControls = false,
  forceShowThumbnail = false,
  loadOnIntersect = false,
  muted: initialMuted = false,
  imageComponent: DefaultImageComponent,
  closedCaptionClassName
}) {
  const [activeDefaultFullScreen, setActiveDefaultFullScreen] = (0, import_react7.useState)(false);
  const [playing, setPlaying] = (0, import_react7.useState)(false);
  const [muted, setMuted] = (0, import_react7.useState)(initialMuted);
  const [videoLoaded, setVideoLoaded] = (0, import_react7.useState)(false);
  const [thumbnailClicked, setThumbnailClicked] = (0, import_react7.useState)(false);
  const videoElement = videoRef != null ? videoRef : (0, import_react7.useRef)(null);
  const containerElement = containerRef != null ? containerRef : (0, import_react7.useRef)(null);
  const toggleMute = () => setMuted(!muted);
  const togglePlay = (0, import_react7.useCallback)(
    (play) => {
      if (!videoElement.current)
        return;
      if (play) {
        void videoElement.current.play();
        setThumbnailClicked(true);
      } else {
        videoElement.current.pause();
      }
      setPlaying(play);
    },
    [videoLoaded, videoElement.current]
  );
  const onVideoLoadedHandler = () => {
    setVideoLoaded(true);
    onVideoLoaded == null ? void 0 : onVideoLoaded();
  };
  const onCloseClickHandler = () => {
    togglePlay(false);
    onCloseClick == null ? void 0 : onCloseClick();
  };
  (0, import_react7.useEffect)(() => {
    if (videoElement.current && !videoLoaded && preload === "auto") {
      videoElement.current.load();
    }
  }, []);
  const onVolumeChangeHandler = (0, import_react7.useCallback)(() => {
    var _a;
    if (!videoLoaded || !videoElement.current)
      return;
    setMuted((_a = videoElement.current) == null ? void 0 : _a.muted);
  }, [videoElement.current]);
  const toggleFullScreen = (0, import_react7.useCallback)(() => {
    if (showDefaultFullScreen && (videoElement == null ? void 0 : videoElement.current)) {
      openFullScreen(videoElement == null ? void 0 : videoElement.current);
    } else {
      onFullScreenClick == null ? void 0 : onFullScreenClick();
    }
  }, [showDefaultFullScreen, fullScreen]);
  const onVideoContainerClickHandler = () => {
    if (document.fullscreenElement != null || document.webkitFullscreenElement != null || document.mozFullScreenElement != null) {
      console.log(
        "Video fullscreen is active. Will use default event handlers."
      );
      return;
    }
    togglePlay(!playing);
  };
  useVideoProgress({
    videoRef: videoElement,
    onProgress
  });
  (0, import_react7.useEffect)(() => {
    if (!videoElement.current)
      return;
    videoElement.current.onfullscreenchange = () => {
      setActiveDefaultFullScreen(document.fullscreenElement !== null);
    };
    videoElement.current.onwebkitfullscreenchange = () => {
      setActiveDefaultFullScreen(document.webkitFullscreenElement !== null);
    };
    videoElement.current.onmozfullscreenchange = () => {
      setActiveDefaultFullScreen(document.fullscreenElement !== null);
    };
  }, [activeDefaultFullScreen, videoElement.current, document]);
  (0, import_react7.useEffect)(() => {
    if (!loadOnIntersect || !(videoElement == null ? void 0 : videoElement.current) || !(containerElement == null ? void 0 : containerElement.current))
      return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          var _a, _b;
          if (entry.isIntersecting) {
            (_a = videoElement == null ? void 0 : videoElement.current) == null ? void 0 : _a.setAttribute("preload", "auto");
            (_b = videoElement == null ? void 0 : videoElement.current) == null ? void 0 : _b.load();
            if (videoElement == null ? void 0 : videoElement.current) {
              observer.unobserve(videoElement == null ? void 0 : videoElement.current);
            }
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1
      }
    );
    observer.observe(videoElement == null ? void 0 : videoElement.current);
  }, [videoElement == null ? void 0 : videoElement.current, loadOnIntersect]);
  const activeCustomFullScreen = !activeDefaultFullScreen && fullScreen;
  const imageProps = {
    src: videoThumbnail,
    width: 0,
    height: 0,
    alt: "Video Thumbnail",
    onClick: () => setThumbnailClicked(true),
    className: (0, import_classnames5.default)(
      videoThumbnailClassName,
      "v2-w-auto v2-h-auto v2-absolute v2-object-cover v2-top-0 v2-cursor-pointer",
      {
        "!v2-z-20": !thumbnailClicked,
        "!v2-z-0 !v2-hidden": thumbnailClicked
      }
    ),
    onLoad: onThumbnailLoad,
    onError: onThumbnailLoadError
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react7.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return videoThumbnail;
      }
    })
  ) : /* @__PURE__ */ import_react7.default.createElement("img", __spreadValues({}, imageProps));
  return /* @__PURE__ */ import_react7.default.createElement(
    "div",
    {
      className: (0, import_classnames5.default)(
        containerClassName,
        "v2-group/video-player v2-overflow-hidden",
        {
          "v2-cursor-pointer v2-inline-flex v2-relative": !fullScreen,
          "v2-fixed v2-transform v2-left-1/2 v2-top-1/2 -v2-translate-x-1/2 ": fullScreen,
          "-v2-translate-y-1/2 v2-translate v2-z-40 v2-w-screen sm:v2-w-auto sm:v2-h-auto v2-flex v2-justify-center": fullScreen,
          "v2-rounded-[10px]": rounded,
          "v2-z-0": !fullScreen
        }
      ),
      ref: containerElement
    },
    /* @__PURE__ */ import_react7.default.createElement(
      "div",
      {
        key: videoUrl,
        className: (0, import_classnames5.default)("v2-flex v2-relative v2-w-full v2-group", {
          "v2-drop-shadow v2-shadow": activeCustomFullScreen
        })
      },
      /* @__PURE__ */ import_react7.default.createElement("div", { className: "v2-w-full", onClick: onVideoContainerClickHandler }, !hideLoader && /* @__PURE__ */ import_react7.default.createElement(
        "span",
        {
          className: (0, import_classnames5.default)(
            "v2-absolute v2-w-full v2-h-full v2-flex v2-flex-col v2-bg-neutral-400",
            {
              "v2-animate-fade-out": videoLoaded
            }
          )
        }
      ), forceShowThumbnail && videoThumbnail && imageComponent, /* @__PURE__ */ import_react7.default.createElement(
        "video",
        {
          id: "bonjoro-video-player",
          ref: videoElement,
          className: (0, import_classnames5.default)("bonjoro-video-player v2-cursor-pointer", {
            "v2-object-cover": !activeDefaultFullScreen,
            "v2-h-full v2-w-full": activeCustomFullScreen,
            [videoClassName != null ? videoClassName : ""]: !fullScreen,
            "!v2-z-0": forceShowThumbnail && !thumbnailClicked,
            "!v2-z-10": forceShowThumbnail && thumbnailClicked
          }),
          style: videoStyle,
          poster: videoThumbnail,
          title: videoTitle,
          controls: showDefaultControls,
          playsInline,
          "webkit-playsinline": playsInline && "webkit-playsinline",
          preload,
          autoPlay,
          muted,
          loop,
          onTouchEnd: (event) => {
            event.preventDefault();
            togglePlay(!playing);
          },
          onTouchMove: (event) => {
            event.preventDefault();
          },
          onPlay: () => {
            togglePlay(true);
            onPlay == null ? void 0 : onPlay();
          },
          onPause: () => {
            togglePlay(false);
            onPause == null ? void 0 : onPause();
          },
          onLoadedData: onVideoLoadedHandler,
          onVolumeChange: onVolumeChangeHandler,
          src: forceFirstFrame ? `${videoUrl}#t=0.001` : videoUrl
        },
        children
      )),
      !showDefaultControls && /* @__PURE__ */ import_react7.default.createElement(
        VideoControls,
        {
          fullScreen,
          playing,
          muted,
          hideClose,
          hideNewTab,
          hidePlayPause,
          hideMuteUnmute,
          hideFullScreen,
          hideTimer,
          hideTranscription,
          onPlayPauseClick: () => togglePlay(!playing),
          onMuteUnmuteClick: toggleMute,
          onFullScreenClick: toggleFullScreen,
          onNewTabClick,
          onCloseClick: onCloseClickHandler,
          ctaHoverColor,
          leftHeaderComponent,
          footerComponent,
          transcription,
          initialTranscriptionState,
          transcriptMode,
          transcriptionTogglerPosition,
          transcriptionMaxWordsPerSentence,
          transcriptionClassName,
          transcriptionContainerClassName,
          showControls: forceShowControls || videoLoaded,
          videoRef: videoElement,
          showProgressBar: videoLoaded && showProgressBar,
          fadeControlsOnPlay,
          closedCaptionClassName,
          playPauseStyle,
          playPauseClassName,
          playPausePlacement
        }
      )
    )
  );
}

// src/components/VideoPlayer/VideoPlayerContainer.tsx
function VideoPlayerContainer(props) {
  const [fullScreen, setFullScreen] = (0, import_react8.useState)(false);
  const toggleFullScreen = () => {
    var _a;
    (_a = props.onFullScreenClick) == null ? void 0 : _a.call(props);
    setFullScreen(!fullScreen);
  };
  const videoPlayerProps = (0, import_react8.useMemo)(() => {
    if (!fullScreen)
      return props;
    return __spreadProps(__spreadValues({}, props), {
      className: "v2-justify-center",
      hideClose: true,
      width: "100%",
      height: "100%"
    });
  }, [props, fullScreen]);
  return /* @__PURE__ */ import_react8.default.createElement(import_react8.default.Fragment, null, /* @__PURE__ */ import_react8.default.createElement(
    VideoPlayerComponent,
    __spreadProps(__spreadValues({}, videoPlayerProps), {
      fullScreen,
      onFullScreenClick: toggleFullScreen
    })
  ), fullScreen && /* @__PURE__ */ import_react8.default.createElement(
    VideoPlayerOverlay,
    {
      className: props == null ? void 0 : props.overlayClassName,
      onClick: toggleFullScreen
    }
  ));
}

// src/components/VideoPlayer/index.tsx
var VideoPlayerPlayPausePlacement = /* @__PURE__ */ ((VideoPlayerPlayPausePlacement2) => {
  VideoPlayerPlayPausePlacement2["Center"] = "center";
  VideoPlayerPlayPausePlacement2["LowerLeft"] = "lower-left";
  return VideoPlayerPlayPausePlacement2;
})(VideoPlayerPlayPausePlacement || {});
